<template>
  <base-header
    :settings="settings"
    :is-addition-disabled="isAdditionDisabled"
    :is-deletion-disabled="isDeletionDisabled"
    :disabled="disabled"
    v-on="$listeners"
  >
    <span :id="`menu-for-${settings.week_day}-${settings.index}`">Disparo realizado toda</span>
    <span class="ml-1 text-picker d-flex" @click.stop="openWeekPicker"
      >{{ settings.week_day }} <v-icon class="text-picker" small>mdi-chevron-down</v-icon></span
    >
    <v-menu
      v-model="weekPickerMenu"
      :disabled="disabled"
      :attach="`#menu-for-${settings.week_day}-${settings.index}`"
      bottom
      origin="center center"
      transition="scale-transition"
    >
      <v-list>
        <v-list-item v-for="weekDay in weekDays" :key="weekDay" @click.native.stop="setWeek(weekDay)">
          <v-list-item-title>{{ weekDay }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </base-header>
</template>

<script>
import BaseHeader from './BaseHeader.vue'

export default {
  name: 'RecurrentHeaderDispatchPanel',
  components: { BaseHeader },
  props: {
    settings: {
      type: Object,
      required: true,
    },
    isAdditionDisabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    isDeletionDisabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      day: 'segunda-feira',
      weekPickerMenu: false,
      weekDays: ['segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado', 'domingo'],
    }
  },
  methods: {
    openWeekPicker() {
      this.weekPickerMenu = true
    },
    setWeek(weekDay) {
      this.$emit('update-header', { updateDispatchModel: 'updateRecurrentDate', value: weekDay })
      this.weekPickerMenu = false
    },
  },
}
</script>
